import { t } from './src-utils-translations.js';

const isDesignPage = () => {
  const path = window.location.pathname;
  if (path.includes(t("my-account-projects")) || path.includes(t("my-account-uploads"))) {
    return false;
  }
  if (path.includes(t("design")) || path.includes("/design")) {
    return true;
  }
  return false;
};
const updateDesignButtonState = (innerText, disableButton) => {
  const buttonName = "onlineBtn";
  const startButton = document.getElementById(buttonName);
  const loader = document.getElementById("loader");
  if (startButton) {
    if (innerText && startButton.childNodes && startButton.childNodes.length) {
      if (startButton.childNodes.length > 1) {
        startButton.childNodes[1].nodeValue = innerText;
      } else startButton.innerText = innerText;
    }
    startButton.disabled = disableButton;
  }
  if (loader) loader.style.display = "none";
};
const hideDesignHelpButton = () => {
  if (isDesignPage()) {
    const buttonName = "onlineBtn";
    const startButton = document.getElementById(buttonName);
    if (startButton) {
      startButton.style.display = "none";
      startButton.disabled = true;
    }
  }
};

export { hideDesignHelpButton, isDesignPage, updateDesignButtonState };
//# sourceMappingURL=src-utils-chat-design-page-utils.js.map
